import React from 'react';
import { useQuery } from 'react-query';
import externalApi from '../../api';
import { IUser } from '../../models';

function fetchTechnicians(): Promise<IUser[]> {
  return externalApi.get(`User/technicians`).json();
}

export function useTechnicians() {
  return useQuery(['Technicians'], () => fetchTechnicians());
}
